import React from 'react';
import PropTypes from 'prop-types';
import '../../../../_modules/jquery_plugins/single_line_expandable';
import sumUpOpeningHours from '../../../helper/sum_up_opening_hours';
import Overview from './station/overview';
import Details from './station/details';
import FooterActions from './station/footer_actions';
import { generateClassName } from '../../../../_modules/helper/generate_class_name';
import ClosureInfo from './station/closure_info';
import DisableInfo from './station/disable_info';
import { size } from '../../../../../lib/utilities';
import { setValue } from '../../../../utilities/local_storage';
import {
  show as showClearanceLightbox,
  hide as hideClearanceLightbox,
} from '../../../../_flux/actions/clearance_info_light_box_actions';
import LightboxActions from '../../../actions/lightbox_actions';
import FittingStationFinderConstants from '../../../constants/fitting_station_finder_constants';
import FinderComponent from './finder';

const lazyClassNames = generateClassName({
  'fsf-station': true,
  'fsf-station--show-details': ({ inDetailMode }) => inDetailMode,
  'fsf-station--selected': ({ isSelected }) => isSelected,
  'fsf-station--hovered': ({ isHovered, disableFitter }) => isHovered && !disableFitter,
  'fsf-station--hovered-and-disabled': ({ isHovered, disableFitter }) => isHovered && disableFitter,
  'fsf-station--no-tyre': ({ showSelectStationButton }) => !showSelectStationButton,
  'details-with-closure': ({ inDetailMode, data }) => inDetailMode && data.deactivatedInFsf,
});

class FinderStation extends React.Component {
  constructor(props) {
    super(props);
    this.bindCallbacks();
  }

  bindCallbacks() {
    this._onSelectStationClick = this._onSelectStationClick.bind(this);
    this._onDetailModeClick = this._onDetailModeClick.bind(this);
  }

  componentDidMount() {
    $(this.refs.station).hover(this._onStationHover.bind(this), this._onStationHoverEnd.bind(this));
    $('.fsf-station__detail-info--single-line-expandable', this.refs.station).singleLineToggle();
  }

  render() {
    const props = this.props;
    const isMobileFitter = this._displayMobileFittingServices();
    const data = props.data;
    const classNames = lazyClassNames(props);
    const isMarketplaceSeller = data.isMarketplaceSeller === true || data.isMarketplaceSeller === 'true';
    const mpsDoesSameDayFitting = data.mpsDoesSameDayFitting === true || data.mpsDoesSameDayFitting === 'true';
    const productStock = data.hasOwnProperty('productStock') ? data.productStock : null;

    const wheelAlignment2 = props.wheelAlignment2;
    const wheelAlignmentwheels_2 = data.wheelAlignment.wheels_2;
    const wheelAlignment4 = props.wheelAlignment4;
    const wheelAlignmentwheels_4 = data.wheelAlignment.wheels_4;

    const wheelAlignment = wheelAlignment2 ? wheelAlignmentwheels_2 : wheelAlignment4 ? wheelAlignmentwheels_4 : '';
    const wheelAlignmentWheelCount = wheelAlignment2 ? 2 : wheelAlignment4 ? 4 : 0;

    const onWheels2Change = (isChecked) => props.onWheels2Change(data.id, isChecked);
    const onWheels4Change = (isChecked) => props.onWheels4Change(data.id, isChecked);
    const onDetailModeClick = this._onDetailModeClick;

    const stationContentsClassnames =
      props.inDetailMode && data.deactivatedInFsf
        ? 'fsf-station__contents scrollbar-inner contents-with-closure'
        : 'fsf-station__contents scrollbar-inner';

    const disableFitter = props.disableFitter;

    return (
      <section ref="station" className={classNames} data-station-id={props.data.id}>
        {!disableFitter && (
          <ClosureInfo
            deactivatedInFsf={data.deactivatedInFsf}
            deactivatedInFsfFrom={data.deactivatedInFsfFrom}
            deactivatedInFsfUntil={data.deactivatedInFsfUntil}
          />
        )}
        {disableFitter && (
          <DisableInfo
            deactivatedInFsf={data.deactivatedInFsf}
            deactivatedInFsfFrom={data.deactivatedInFsfFrom}
            deactivatedInFsfUntil={data.deactivatedInFsfUntil}
          />
        )}
        <div ref="stationContents" className={stationContentsClassnames}>
          <Overview
            brandImage={data.brandImage || ''}
            distance={Math.ceil(data.distance / 1000) + ' Km'}
            address={props.showDisplayName ? data.displayName : data.address}
            isMobileFitter={isMobileFitter}
            displayName={data.displayName}
            name={data.displayName}
            inDetailMode={props.inDetailMode}
            reviewCount={data.reviews.reviewCount}
            average={data.reviews.averageRating}
            showSelectStationButton={props.showSelectStationButton}
            onDetailModeClick={onDetailModeClick}
            showAllCosts={props.showAllCosts}
            onShowAllCostsClick={props.onShowAllCostsClick}
            onHideAllCostsClick={props.onHideAllCostsClick}
            wheelsData={data.wheelAlignment}
            totalPrice={data.totalPrice}
            totalShipping={data.totalShipping}
            calloutFee={data.calloutFee}
            etaFrom={data.etaFrom}
            etaTo={data.etaTo}
            totalCart={props.totals}
            wheelAlignmentWheelCount={wheelAlignmentWheelCount}
            wheelAlignment={wheelAlignment}
            wheelAlignment2IsShowable={data.wheelAlignment.wheels_2_is_showable}
            wheelAlignment4IsShowable={data.wheelAlignment.wheels_4_is_showable}
            fittingPromotion={data.fittingPromotion}
            productsQty={props.productsQty}
            productBrand={props.productBrand}
            onWheels2Change={onWheels2Change}
            onWheels4Change={onWheels4Change}
            staticUrl={props.staticUrl}
            store={props.store}
            isMarketplaceSeller={isMarketplaceSeller}
            mpsDoesSameDayFitting={mpsDoesSameDayFitting}
            mpsDoesSameDayFittingCutoff={data.mpsDoesSameDayFittingCutoff}
            productStock={productStock}
            vehicleCollectAndReturnService={data.vehicleCollectAndReturnService}
            disableFitter={disableFitter}
            allDiscounts={data.allDiscounts}
            sponsored={data.sponsored}
            logoImage={data.logoImage}
            primaryColor={data.primaryColor}
            secondaryColor={data.secondaryColor}
            mapMarkerImage={data.mapMarkerImage}
          />

          <Details
            isMobileFitter={isMobileFitter}
            mobileFittingPostCodes={data.mobileFittingPostCodes}
            openingHours={sumUpOpeningHours(data.openingHours)}
            displayAdditionalServices={this._displayAdditionalServices()}
            wheelAlignment={data.wheelAlignment}
            image={data.image}
            address={data.address}
            reviews={data.reviews}
            onWheels2Change={onWheels2Change}
            onWheels4Change={onWheels4Change}
            showSelectStationButton={props.showSelectStationButton}
            wheelAlignment2={props.wheelAlignment2}
            wheelAlignment4={props.wheelAlignment4}
            onShowMoreWheelAlignmentInfoClick={props.onShowMoreWheelAlignmentInfoClick}
            fittingCosts={props.serviceTotals}
            totalPrice={props.serviceTotals}
            totalShipping={data.totalShipping}
            calloutFee={data.calloutFee}
            totalCart={props.totals}
            wheelAlignmentWheelCount={wheelAlignmentWheelCount}
            wheelAlignmentwheels_2={wheelAlignmentwheels_2}
            wheelAlignmentwheels_4={wheelAlignmentwheels_4}
            productsPrice={props.productsPrice}
            productsQty={props.productsQty}
            productBrand={props.productBrand}
            productModel={props.productModel}
            productManufacturer={props.productManufacturer}
            productDimensions={props.productDimensions}
            isMarketplaceSeller={isMarketplaceSeller}
            mpsDoesSameDayFitting={mpsDoesSameDayFitting}
            mpsDoesSameDayFittingCutoff={data.mpsDoesSameDayFittingCutoff}
            productStock={productStock}
            vehicleCollectAndReturnService={data.vehicleCollectAndReturnService}
            vehicleCollectAndReturnServiceComment={data.vehicleCollectAndReturnServiceComment}
            discount={data.discount}
            discountInfo={data.discountInfo}
            allDiscounts={data.allDiscounts}
            buy4Pay3={props.buy4Pay3}
            shippingWarning={props.shippingWarning}
            fsName={data.fsName}
            sponsored={data.sponsored}
            logoImage={data.logoImage}
            primaryColor={data.primaryColor}
            secondaryColor={data.secondaryColor}
            mapMarkerImage={data.mapMarkerImage}
          />
        </div>

        {props.showSelectStationButton && (
          <FooterActions
            totalCart={props.totals}
            shippingTime={data.shippingTime}
            totalShipping={data.totalShipping}
            onSelectStationClick={this._onSelectStationClick}
            deactivatedInFsf={data.deactivatedInFsf}
            deactivatedInFsfFrom={data.deactivatedInFsfFrom}
            deactivatedInFsfUntil={data.deactivatedInFsfUntil}
            isMarketplaceSeller={isMarketplaceSeller}
            mpsDoesSameDayFitting={mpsDoesSameDayFitting}
            mpsDoesSameDayFittingCutoff={data.mpsDoesSameDayFittingCutoff}
            productStock={productStock}
            etaFrom={data.etaFrom}
            etaTo={data.etaTo}
          />
        )}
      </section>
    );
  }

  _onDetailModeClick() {
    if (!this.props.inDetailMode) {
      this.props.onDetailModeClick(this.props.data.id);
    }
  }

  _onSelectStationClick() {
    if (this.props.data?.productStock?.clearance) {
      LightboxActions.closeAction();
      FinderComponent.onListModeClick();
      showClearanceLightbox(false, true);
      window.addToCartDeferred = $.Deferred();
      window.addToCartDeferred.then(() => this.onSelectStationClick(this.props, true));
    } else {
      this.onSelectStationClick(this.props);
    }
  }

  onSelectStationClick(props, fromClearance) {
    if (window.isCustomSearchClicked) {
      const { data } = props;
      const latLng = {
        lat: data.latitude,
        lng: data.longitude,
      };
      const postcode = `${data.postcode}, ${data.suburb}`;
      setValue('shippingPostcode', postcode);
      setValue('shippingState', data.state);
      setValue('latLng', latLng);
      setValue('bust', true);
      window.isCustomSearchClicked = false;
    }
    props.onStationSelect(props.data.id);
    
    if (fromClearance) {
      hideClearanceLightbox();
      if (this.props.showSuccessPage) {
        LightboxActions.openAction();
      }
    }
  }

  _onStationHover(e) {
    e.stopPropagation();
    if (!this.props.inDetailMode) {
      this.props.onStationHover(this.props.data.id, { stationHovered: true });
    }
  }

  _onStationHoverEnd() {
    if (!this.props.inDetailMode) {
      this.props.onStationHoverEnd();
    }
  }

  getPosition() {
    return $(this.refs.station).position();
  }

  _displayAdditionalServices() {
    return !!size(this.props.data.wheelAlignment);
  }

  _displayMobileFittingServices() {
    return this.props.data.isMobileFitter;
  }
}

FinderStation.propTypes = {
  onShowMoreWheelAlignmentInfoClick: PropTypes.func.isRequired,
  buy4Pay3: PropTypes.bool,
  shippingWarning: PropTypes.string,
};

FinderStation.defaultProps = {
  buy4Pay3: false,
};

export default FinderStation;
